import React,{useEffect,useState,useRef} from 'react'
import processService from '../../services/process.service';
import { useParams, useNavigate } from 'react-router-dom';

function ProcessEmailPreview() {
    const [htmlContent, setHtmlContent] = useState('')
    const [emailSubject,setEmailSubject] = useState(null)
    const {processId} = useParams()
    const navigate = useNavigate()
    useEffect(()=>{
        getEmailProcess()
    },[])

    const getEmailProcess = ()=>{
        processService.getEmailQueueById(processId)
        .then(res=>{
              setHtmlContent(res.data.contentPath)
              setEmailSubject(res.data.emailSubject)
        })
        .catch(err=>{
          console.log(err)
        })
    }

    const handleBack = ()=>{
      navigate(-1)
    }
  return (
    <>
    <div className="container container-xxl">
      <div className="d-flex justify-content-between align-items-center">
        <p className='text-danger'>Note : This is Preview only. Editing wont save anything.</p>
        <button className="btn btn-secondary btn-sm" onClick={handleBack}>Back</button>
      </div>
       
        <div>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </div>
    </div>
   
               
    </>
  )
}

export default ProcessEmailPreview